export enum ReadContractErrors {
  RedeemedToken = 'ERC721NonexistentToken(uint256)',
}
